import React from 'react'
import styles from './subCategories.module.css'

const SortProduct = ({ filter,loading,totalItems,filteredCount,stock,status }) => {
    return (
        <div className={styles.sortedFilter}>
            <div className={styles.sortedFilter}>

                <div style={{ display: 'flex', justifyContent: 'center', gap: 3 }}>
                    {(filter?.length > 0 || stock || status) &&
                        <div>
                            {loading ?
                                <img src="/assets/__Iphone-spinner-1.gif" alt="" style={{ width: 25, height: 25 }} />
                                :
                                <p>{filteredCount} of</p>
                            }
                        </div>
                    }

                    <div>
                        {totalItems} Results
                    </div>
                </div>

            </div>
            {/* <div className={styles.loginInputGroup}>
                <div >
                    <select
                        name="state"
                        className={styles.selectField}
                        defaultValue=""
                    >
                        <option value="" disabled hidden c>Sort by</option>
                        <option value="State 1">State 1</option>
                        <option value="State 2">State 2</option>
                    </select>
                </div>
                <div className={styles.selectArrowIcon}>
                    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L7 7L13 1" stroke="#9F9F9F" />
                    </svg>
                </div>
            </div> */}
        </div>
    )
}

export default SortProduct
